<a
  [routerLink]="routeSegments()"
  [routerLinkActiveOptions]="{ exact: isExactRoute() }"
  routerLinkActive=""
  #rla="routerLinkActive"
  class="flex h-12 items-center gap-x-1 rounded px-3.5 text-x-small font-bold text-text-000 hover:bg-primary-600 dark:text-text-700 dark:hover:bg-primary-400 md:px-3 sm:justify-start sm:border sm:border-primary-450 sm:px-4 sm:py-4 sm:dark:border-primary-700"
  [ngClass]="rla.isActive ? ['bg-secondary-500', 'dark:bg-primary-600'] : null"
  [class.pointer-events-none]="!isSideMenuOpen()"
  (click)="onNavigationClick($event)"
>
  @if (iconKey(); as iconKey) {
    <div class="sm:hidden">
      <svg-icon [key]="iconKey" />
    </div>
  }
  @if (isSideMenuOpen()) {
    <span class="sm:text-large">{{ label() }}</span>
  }
</a>
